import { BaseRomanBlinds } from '../constants/productTypes';
import { ProductBuilderMachineContext } from '../types';

export const isRomanBlinds = ({ products }: ProductBuilderMachineContext) => {
  const romanBlindsChainProductType: BaseRomanBlinds = 'Roman Blinds Chain';
  const romanBlindsChainlessProductType: BaseRomanBlinds =
    'Roman Blinds Chainless';

  return (
    products[0].type.includes(romanBlindsChainProductType) ||
    products[0].type.includes(romanBlindsChainlessProductType)
  );
};
